import H4 from "@/components/ui/headings/H4";
import HoverDropdownButton from "@/components/ui/hover-dropdown-button";
import Iconify from "@/components/ui/Iconify";
import Span from "@/components/ui/Span";
import { timeAgo, timeAgoInKorean } from "@/utils/helpers";
import TagHighlighter from "../content-sections/content-details-section/content-tag-highlighter";
import { useLocale, useTranslations } from "@/lib/static-intl";
import { useAuthContext } from "@/context/auth/useAuthContext";
import { buildPlaceDetailPath } from "@/constants/routes";
import { useRouter } from "next/navigation";

const PostTitleDescSection = ({
  selectedPostInModal,
  triggerReportModal,
  allUsersForTagging,
  currentUserFollowing,
  setCurrentUserFollowing,
}) => {
  const { user } = useAuthContext();
  const router = useRouter();
  const locale = useLocale();
  const explorePostDetailsT = useTranslations("explore.explore_post_details");
  return (
    <div className="w-full flex flex-col p-5 gap-y-2 border-b border-black/[0.06] dark:border-white/[0.10]">
      <H4>{selectedPostInModal?.title}</H4>
      <TagHighlighter
        selectedPostInModal={selectedPostInModal}
        allUsersForTagging={allUsersForTagging}
        currentUserFollowing={currentUserFollowing}
        setCurrentUserFollowing={setCurrentUserFollowing}
      />
      <div className="w-full flex items-center justify-center">
        <div className="w-full flex items-center gap-3">
          <Span className="!text-[14px] !leading-[17px] dark:!text-dark_tertiary_label text-nowrap">
            {locale === "en"
              ? timeAgo(selectedPostInModal?.createdAt)
              : timeAgoInKorean(selectedPostInModal?.createdAt)}
          </Span>
          {/* 장소로 가는 길. 예전에는 날짜 옆 회색 글씨라 누를 수 있는지 몰랐고,
              새 탭으로 열려 앱 밖으로 튀어나갔다. 영상 상세와 같은 핀 칩으로 맞춘다. */}
          {(selectedPostInModal?.place?.id ||
            selectedPostInModal?.place?._id ||
            selectedPostInModal?.place?.publicId) && (
            <button
              type="button"
              className="flex min-w-0 items-center gap-1 rounded-full bg-black/[0.05] px-2.5 py-1 text-[13px] font-semibold text-black/70 transition active:scale-[0.98] dark:bg-white/10 dark:text-white/70"
              onClick={() => {
                const placePath = buildPlaceDetailPath(selectedPostInModal?.place);
                if (placePath) router.push(placePath);
              }}
            >
              <Iconify icon="lucide:map-pin" className="!h-4 !w-4 shrink-0" />
              <span className="truncate">
                {selectedPostInModal?.place?.name ||
                  selectedPostInModal?.place?.address ||
                  selectedPostInModal?.place?.city ||
                  selectedPostInModal?.place?.state ||
                  selectedPostInModal?.place?.country}
              </span>
            </button>
          )}
          {selectedPostInModal?.rating > 0 && (
            <div className="flex item-center">
              {[...Array(5)].map((_, index) => (
                <span
                  key={index}
                  className={
                    index < Math.floor(selectedPostInModal?.rating)
                      ? "text-amber-400 text-lg"
                      : "text-black/15 dark:text-white/20 text-lg"
                  }
                >
                  ★
                </span>
              ))}
            </div>
          )}
        </div>
        {
          user && user.userId !== selectedPostInModal?.userId &&
          <div className="relative z-[9999] max-md:hidden">
            <HoverDropdownButton
              className={""}
              dropdownClasses={"right-4 !top-8 !z-[9999]"}
              options={[
                {
                  id: "1r",
                  label: explorePostDetailsT("report"),
                  icon: null,
                  link: null,
                  isHidden: false,
                  onClick: triggerReportModal,
                },
              ]}
            >
              <Iconify icon={"mi:options-horizontal"} className={"!w-4 !h-4"} />
            </HoverDropdownButton>
          </div>
        }
      </div>
    </div>
  );
};

export default PostTitleDescSection;
